import {Form, Select} from 'antd';

import {SelectCatalogOption} from '../../../layout/select/select-catalog-option';
import {StoreRuleAppType} from '../../../provider/catalogs/catalogs-type';
import {Locale} from '../../../provider/locale/locale';
import {LangKeyType} from '../../../provider/locale/translation/type';
import {FormInstance} from '../../../typings/antd';

import {AutoReplyFormFieldNameEnum} from './auto-reply-form-const';
import {StoreSourceType} from './auto-reply-form-store-source-helper';

const {Option} = Select;

type PropsType = {
    catalogNamesIsInProgress: boolean;
    form: FormInstance<Record<string, unknown>>;
    getLocalizedString: (stringKey: LangKeyType) => string;
    storeApps: Array<StoreRuleAppType>;
    storeAppsIsInProgress: boolean;
    storeCatalogs: Array<StoreSourceType>;
};

export function AutoReplyFormFiltersStore(props: PropsType): JSX.Element {
    const {catalogNamesIsInProgress, form, getLocalizedString, storeApps, storeAppsIsInProgress, storeCatalogs} = props;

    const selectedCatalogId = Form.useWatch<number | null>(AutoReplyFormFieldNameEnum.StoreCatalog, form);
    const selectedCatalogApps = selectedCatalogId ? storeApps.filter((app) => app.catalogId === selectedCatalogId) : [];

    return (
        <>
            <Form.Item
                label={<Locale stringKey="AUTO_REPLIES__FORM__FEEDBACK_SOURCE" />}
                name={AutoReplyFormFieldNameEnum.StoreCatalog}
                rules={[{required: true, message: getLocalizedString('VALIDATION__ERROR__FIELD_IS_REQUIRED')}]}
            >
                <Select<number>
                    loading={storeAppsIsInProgress || catalogNamesIsInProgress}
                    onChange={() => {
                        form.setFieldValue(AutoReplyFormFieldNameEnum.BrandCatalogCompany, null);
                    }}
                    placeholder={getLocalizedString('AUTO_REPLIES__FORM__SELECT_SOURCES')}
                    showSearch={false}
                    size="large"
                >
                    {storeCatalogs.map(SelectCatalogOption)}
                </Select>
            </Form.Item>

            <Form.Item
                label={<Locale stringKey="AUTO_REPLIES__FORM__APPLICATIONS" />}
                name={AutoReplyFormFieldNameEnum.BrandCatalogCompany}
                rules={[{required: true, message: getLocalizedString('VALIDATION__ERROR__FIELD_IS_REQUIRED')}]}
            >
                <Select<number>
                    disabled={!selectedCatalogId}
                    loading={storeAppsIsInProgress}
                    placeholder={getLocalizedString('AUTO_REPLIES__FORM__SELECT_APPLICATIONS')}
                    showSearch={false}
                    size="large"
                >
                    {selectedCatalogApps.map((app) => (
                        <Option key={app.id} value={app.id}>
                            {app.appName || app.appId || app.website}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </>
    );
}
